import { render } from "./NButton.vue?vue&type=template&id=0bb9dbe1&ts=true"
import script from "./NButton.vue?vue&type=script&lang=ts"
export * from "./NButton.vue?vue&type=script&lang=ts"

import "./NButton.vue?vue&type=style&index=0&id=0bb9dbe1&lang=stylus"

import exportComponent from "/tmp/ffsecurity-ui/packages/v2/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__